/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_samlAcs } from '../models/Body_samlAcs';
import type { SamlInitResponse } from '../models/SamlInitResponse';
import type { SamlLogoutResponse } from '../models/SamlLogoutResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SamlService {
    /**
     * Init SAML request
     * Initialize SAML authentication flow.
     * @returns SamlInitResponse Successful Response
     * @throws ApiError
     */
    public static initSamlAuth(): CancelablePromise<SamlInitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/saml/init',
        });
    }
    /**
     * Get service as SP metadata
     * Return SP metadata XML with tenant-specific configuration.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getMetadata(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/saml/metadata',
        });
    }
    /**
     * SAML Assertion Consumer Service
     * Endpoint to receive and process SAML responses from IdP.
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static samlAcs(
        formData: Body_samlAcs,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/saml/acs',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * SAML logout with session clearing
     * Logout user by clearing session and initiating SAML Single Logout (SLO) flow
     * @param userSession
     * @returns SamlLogoutResponse Successful Response
     * @throws ApiError
     */
    public static samlLogout(
        userSession?: (string | null),
    ): CancelablePromise<SamlLogoutResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/saml/logout',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * SAML logout complete
     * Endpoint to receive and process SAML logout complete response from IdP.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static samlLogoutComplete(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/saml/logout-complete',
        });
    }
}
